<template>
  <div class="main-table-cell-wrap" :title="displayTitle">
    <span v-if="isHtml" v-html="displayValue" class="main-table-txt"></span>
    <span v-else class="main-table-txt" v-text="displayValue"></span>
  </div>
</template>
<script>
import util from '../../libs/util'

export default {
  name: 'grid-table-cell',
  props: {
    columnConfig: {
      type: Object,
      default() {
        return {}
      }
    },
    columnValue: {
      type: [Object, String, Number],
      default() {
        return undefined
      }
    },
    query: {
      type: String,
      default: undefined
    },
    // 级联选择器选中值label储存对象
    cascadeSearchLabels: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      isHtml: this.columnConfig.originalIsHtml,
      displayTitle: ''
    }
  },
  computed: {
    displayValue() {
      let colValue = this.columnValue
      // 默认使用显示索引，级联选择查询需要精确搜索Id，要用searchColumnIndex
      let searchIndex = this.columnConfig.searchColumnIndex ? this.columnConfig.searchColumnIndex : this.columnConfig.dataIndex
      // 搜索条件为精确搜索id时高亮显示对应value值
      let queryLabelValue = this.cascadeSearchLabels[searchIndex]
      if (queryLabelValue) {
        if (colValue || colValue === 0) {
          colValue = colValue + '' // 将colValue转为String类型
          if (this.columnConfig.originalIsHtml) {
            let value = colValue.replace(/<[^>]*>|/g, '') // 去掉原有html样式，获取纯文本
            if (queryLabelValue.indexOf(colValue) !== -1) {
              let escapeRegExp = util.regExp2Escape(colValue)
              let newValue = value.replace(new RegExp(escapeRegExp, 'gm'), '<span class="red">' + colValue + '</span>')
              colValue = colValue.replace(value, newValue) // 替换原值中纯文本
              this.$set(this.columnConfig, 'isHtml', true)
              this.isHtml = true
            } else {
              this.$set(this.columnConfig, 'isHtml', this.columnConfig.originalIsHtml)
              this.isHtml = this.columnConfig.originalIsHtml
            }
          } else {
            if (queryLabelValue.indexOf(colValue) !== -1) {
              let escapeColValue = util.html2Escape(colValue)
              let escapeRegExp = util.regExp2Escape(escapeColValue)
              colValue = escapeColValue.replace(new RegExp(escapeRegExp, 'gm'), '<span class="red">' + escapeColValue + '</span>')
              this.$set(this.columnConfig, 'isHtml', true)
              this.isHtml = true
            } else {
              this.$set(this.columnConfig, 'isHtml', this.columnConfig.originalIsHtml)
              this.isHtml = this.columnConfig.originalIsHtml
            }
          }
        }
      } else {
        let query = this.query
        if (query && query.trim()) {
          query = query.trim()
          if (colValue || colValue === 0) {
            colValue = colValue + '' // 将colValue转为String类型
            if (this.columnConfig.originalIsHtml) {
              let value = colValue.replace(/<[^>]*>|/g, '') // 去掉原有html样式，获取纯文本
              if (util.indexOfIgnoreCase(value, query) !== -1) {
                let escapeRegExp = util.regExp2Escape(query)
                let newValue = value.replace(new RegExp(escapeRegExp, 'gm'), '<span class="red">' + query + '</span>')
                colValue = colValue.replace(value, newValue) // 替换原值中纯文本
                this.$set(this.columnConfig, 'isHtml', true)
                this.isHtml = true
              } else {
                this.$set(this.columnConfig, 'isHtml', this.columnConfig.originalIsHtml)
                this.isHtml = this.columnConfig.originalIsHtml
              }
            } else {
              if (util.indexOfIgnoreCase(colValue, query) !== -1) {
                let escapeColValue = util.html2Escape(colValue)
                let escapeQuery = util.html2Escape(query)
                let escapeRegExp = util.regExp2Escape(escapeQuery)
                colValue = escapeColValue.replace(new RegExp(escapeRegExp, 'gm'), '<span class="red">' + escapeQuery + '</span>')
                this.$set(this.columnConfig, 'isHtml', true)
                this.isHtml = true
              } else {
                this.$set(this.columnConfig, 'isHtml', this.columnConfig.originalIsHtml)
                this.isHtml = this.columnConfig.originalIsHtml
              }
            }
          }
        } else {
          this.$set(this.columnConfig, 'isHtml', this.columnConfig.originalIsHtml)
          this.isHtml = this.columnConfig.originalIsHtml
        }
      }
      this.displayTitle = this.isHtml ? util.clearHtml(colValue) : colValue
      return colValue
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/grid/grid-table-cell.vue